import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MotionConfig } from 'motion/react';
import App from './App';
import AvisoVersion from './components/AvisoVersion';
import './styles/global.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Falta el contenedor #root en index.html');

createRoot(raiz).render(
  <StrictMode>
    {/* «Reducir movimiento» del sistema apaga los desplazamientos de Motion; la opacidad queda. */}
    <MotionConfig reducedMotion="user">
      <App />
      <AvisoVersion />
    </MotionConfig>
  </StrictMode>,
);
